import { render, staticRenderFns } from "./MaterialsRelatory.vue?vue&type=template&id=1a6bbea0&scoped=true"
import script from "./MaterialsRelatory.vue?vue&type=script&lang=js"
export * from "./MaterialsRelatory.vue?vue&type=script&lang=js"
import style0 from "./MaterialsRelatory.vue?vue&type=style&index=0&id=1a6bbea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6bbea0",
  null
  
)

export default component.exports